import { createSagaAction } from '../../../../shared/sagas'
import { createReducer } from '../../../../shared/reducers'

// Constants
export const constants = {
  PAYMENT_REQUEST_REPORT_GET_JOB_LIST: createSagaAction('PAYMENT_REQUEST_REPORT_GET_JOB_LIST'),
  PAYMENT_REQUEST_REPORT_GET_ORGANIZATION_LIST: createSagaAction(
    'PAYMENT_REQUEST_REPORT_GET_ORGANIZATION_LIST'
  ),
  PAYMENT_REQUEST_REPORT_GET_FULL_REPORT: createSagaAction('PAYMENT_REQUEST_REPORT_GET_FULL_REPORT')
}

// Action Creators
export const actions = {
  paymentRequestReportGetJobList: ({ filters }) => ({
    type: constants.PAYMENT_REQUEST_REPORT_GET_JOB_LIST.ACTION,
    filters
  }),
  paymentRequestReportGetOrganizationList: ({ filters }) => ({
    type: constants.PAYMENT_REQUEST_REPORT_GET_ORGANIZATION_LIST.ACTION,
    filters
  }),
  paymentRequestReportGetFullReport: ({ filters }) => ({
    type: constants.PAYMENT_REQUEST_REPORT_GET_FULL_REPORT.ACTION,
    filters
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.PAYMENT_REQUEST_REPORT_GET_JOB_LIST.ACTION:
      return { ...state, error: null, loadingJobList: true }
    case constants.PAYMENT_REQUEST_REPORT_GET_JOB_LIST.SUCCESS:
      return { ...state, error: null, loadingJobList: false, jobList: action.payload }

    case constants.PAYMENT_REQUEST_REPORT_GET_ORGANIZATION_LIST.ACTION:
      return { ...state, error: null, loadingOrganizationList: true }
    case constants.PAYMENT_REQUEST_REPORT_GET_ORGANIZATION_LIST.SUCCESS:
      return {
        ...state,
        error: null,
        loadingOrganizationList: false,
        organizationList: action.payload
      }

    case constants.PAYMENT_REQUEST_REPORT_GET_FULL_REPORT.ACTION:
      return { ...state, error: null, loadingFullReport: true }
    case constants.PAYMENT_REQUEST_REPORT_GET_FULL_REPORT.SUCCESS:
      return {
        ...state,
        error: null,
        loadingFullReport: false,
        fullReport: action.payload
      }

    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/reports/financial/paymentRequestReportActions.js